import { Field, TextOutput } from 'Components/Core';
import { withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection } from 'Components/Layout';
import { IWorksheetComponent } from 'Components/Worksheets/Core';
import React from 'react';

let LaboratoryResults: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  return (
    <>
      <ListFieldSection heading="Laboratory Results">
        <Field input={<TextOutput />} name="Results.MaximumDryDensity" emph />
        <Field input={<TextOutput />} name="Results.OptimumMoistureContent" emph />
      </ListFieldSection>
    </>
  );
};

LaboratoryResults = withInjectedProps(LaboratoryResults);

export { LaboratoryResults };
export default LaboratoryResults;
